import { dataUser } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUser = /*#__PURE__*/createIcon(dataUser)
export default IconUser
